import React, { useState, useEffect } from 'react';
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import './Loader.css';

const headings = [
  { title: 'Processing your requirements', percentage: 15 },
  { title: 'Analysing your plot and family details', percentage: 25 },
  { title: 'Adjusting the plan according to your future needs', percentage: 35 },
  { title: 'Considering your structure choice', percentage: 45 },
  { title: 'Analyzing front facade for 3D Elevation', percentage: 55 },
  { title: 'Prepairing Photorealistic 3D Elevation', percentage: 70 },
  { title: 'Creating multiple options', percentage: 80 },
  { title: 'Prepairing final 2D & 3D designs', percentage: 95 },
  { title: 'Your 2D & 3D Designs are ready', percentage: 100 },
];

const Loader = ({handleNext2}) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [currentHeading, setCurrentHeading] = useState(headings[currentIndex]);
  const [percentage, setPercentage] = useState(0);
  const [showHeading, setShowHeading] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      if (percentage < currentHeading.percentage) {
        setPercentage((prevPercentage) => Math.min(prevPercentage + 1, currentHeading.percentage));
      } else if (currentIndex + 1 < headings.length) {
        clearInterval(interval);
        setCurrentIndex(currentIndex + 1);
        setCurrentHeading(headings[currentIndex + 1]);
      }else{
        handleNext2()
      }
    }, 200); // Adjust this interval for smoother transitions

    return () => clearInterval(interval);
  }, [currentIndex, currentHeading, percentage]);

  useEffect(() => {
    // Show the heading with a slight delay after the loader animation
    const headingTimeout = setTimeout(() => {
      setShowHeading(true);
    }, 120); // Adjust this delay as needed

    return () => clearTimeout(headingTimeout);
  }, []);

  return (
    <div className="loader-parent">
       <div className="brandmain_logo-new">
              <img
              loading="lazy"
              src="/images/logo.png"
              className="img-fluid"
              alt=""
              >
              </img>
            </div>
      <div className='card_new-ai'>
      <div className="progressbar-container">
        <CircularProgressbar
          value={percentage}
          text={`${percentage} %`}
          styles={buildStyles({
            root: { width: '100%' },
            path: {
              stroke: `rgba(62, 152, 199, ${percentage / 100})`,
              strokeLinecap: 'butt',
            },
            text: {
              fill: '#f88',
              fontSize: '16px',
            },
          })}
        />
        </div>
        {showHeading && (
          <h1 className='loader-hdng '  >{currentHeading.title}</h1>
        )}
      </div>
    </div>
  );
};

export default Loader;
